import * as customerConstants from '../customerConstants';

import useCustomerInterest from './useCustomerInterest';


function useIsSellerCustomer() {

    const customerInterest = useCustomerInterest();

    return customerConstants.CUSTOMER_INTEREST_SELLER === customerInterest;
}


export default useIsSellerCustomer;
